import di from 'di'

import UserRole from 'app/enums/UserRole';
import Permission from 'app/enums/Permission';

import Acl from '@wittignl/js-core/plugins/Acl'
import { Events as AuthEvents } from '@wittignl/js-core/plugins/Authentication'

export default class {

    run() {

        const acl = new Acl();

        acl.role(UserRole.USER, [Permission.ROUTE_ACCOUNT]);
        acl.role(UserRole.RESIDENT, [], UserRole.USER);
        acl.role(UserRole.CONTRACTOR, [], UserRole.USER);
        acl.role(UserRole.SUPPLIER, [], UserRole.USER);
        acl.role(UserRole.SUPPLIER_ALTITUDE, [], UserRole.USER);
        acl.role(UserRole.SUPPLIER_VIBRATION, [], UserRole.USER);
        acl.role(UserRole.WORKER, [], UserRole.USER);
        acl.role(UserRole.ADVISOR_EXTERNAL, [], UserRole.USER);
        acl.role(UserRole.ADVISOR, [Permission.ROUTE_PROJECTS, Permission.ROUTE_ACCOUNT]);
        acl.role(UserRole.ADMIN, Permission.all());


        this.loadRole(acl);

        const auth = di.get('auth');
        auth.on(AuthEvents.LOGIN, () => this.loadRole(acl));
        auth.on(AuthEvents.LOGOUT, () => acl.clearPermissions());

        di.set('acl', acl);
    }

    loadRole(acl){

        const auth = di.get('auth');
        const session = auth.getSession();

        if(session) {

            const user = session.getIdentity();
            acl.setActiveRole(user.role);
        }
    }
}
